import { RedeemRedemptionCodeResponse } from 'rpc/model/squareup/rewards/service';

export const REDEEM_TERMS_URL =
  '/legal/general/promotion-terms-conditions/reader-discount-redemption';

export const DASHBOARD_URL = '/dashboard';

export const parseResponseError = (
  responseStatus: RedeemRedemptionCodeResponse.Status,
): string => {
  switch (responseStatus) {
    case RedeemRedemptionCodeResponse.Status.NOT_FOUND: {
      return 'redeem.error.notFound';
    }
    case RedeemRedemptionCodeResponse.Status.DUPLICATE_CODE_REDEMPTION: {
      return 'redeem.error.claimed';
    }
    case RedeemRedemptionCodeResponse.Status.DUPLICATE_MERCHANT_REDEMPTION: {
      return 'redeem.error.ineligible';
    }
    case RedeemRedemptionCodeResponse.Status.UNKNOWN:
    default: {
      return 'error.api.generic';
    }
  }
};
